export const sortByPreset = (labels) => {
  let navSortOrder

  if (window.location.href.indexOf('contact-us') >= 0) {
    navSortOrder = [
      'mutual-funds',
      'etfs',
      'managed-accounts',
      'model-portfolios',
      '529-plan',
      'closed-end-funds',
      'retirement-plans-vits',
      'registration-login-issues',
      'retirement-plans',
    ]
  } else if (window.location.href.indexOf('business-building') >= 0) {
    navSortOrder = [
      'advisor-qa-series',
      'conversation-toolkits',
      'workplace-insider',
    ]
  } else if (window.location.href.indexOf('press-center') >= 0) {
    navSortOrder = ['pr-contacts']

    const currentYear = new Date().getFullYear()

    for (let year = currentYear; year >= 2016; year--) {
      navSortOrder.push(year.toString())
    }
    navSortOrder.push('closed-end-funds-news', 'disclosures')
  } else if (
    window.location.href.indexOf(
      'seligman-premium-technology-growth-fund-press-releases'
    ) ||
    window.location.href.indexOf('tri-continental-corporation-press-releases')
  ) {
    navSortOrder = []
    const currentYear = new Date().getFullYear()

    for (let year = currentYear; year >= 2016; year--) {
      navSortOrder.push(year.toString())
    }
  }

  const sortedLabels = labels.sort((a, b) => {
    const aScore = navSortOrder.indexOf(a.navAnchor)
    const bScore = navSortOrder.indexOf(b.navAnchor)

    if (aScore > bScore) {
      return 1
    } else if (aScore < bScore) {
      return -1
    } else {
      return 0
    }
  })

  return sortedLabels
}
